import axios from "axios";
import { StatusMessageResponse } from "../../../common/interfaces/status-message-response";

export async function createModule(data: JSON, token: string): Promise<StatusMessageResponse> {
    try {
      const response = await axios.post(process.env.REACT_APP_BASE_URL+'/modulos', 
        data, 
        {
            headers: {
                Authorization: 'Bearer ' + token
            }
        }
      );
  
      const res = response.data; // Supondo que a resposta de criação seja retornado pelo backend
      return res;
    } catch (error) {
      throw new Error('Falha na criação de um modulo');
    }
}